var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"js-profile-image-div"},[(_vm.isUse())?_c('p',{staticClass:"photo js-settingLayer js-btn-small-setting",attrs:{"data-code":this.code}},[_c('img',{attrs:{"src":_vm.profileImg,"alt":"프로필 사진"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }